"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponStatuses = exports.CodeRecordTypes = exports.CouponTypes = void 0;
var CouponTypes;
(function (CouponTypes) {
    CouponTypes["PROMO"] = "promo";
    CouponTypes["VOUCHER"] = "voucher";
    CouponTypes["DISCOUNT"] = "discount";
})(CouponTypes = exports.CouponTypes || (exports.CouponTypes = {}));
var CodeRecordTypes;
(function (CodeRecordTypes) {
    CodeRecordTypes["CODE"] = "code";
    CodeRecordTypes["USAGE"] = "usage";
})(CodeRecordTypes = exports.CodeRecordTypes || (exports.CodeRecordTypes = {}));
var CouponStatuses;
(function (CouponStatuses) {
    CouponStatuses["ACTIVE"] = "active";
    CouponStatuses["EXPIRED"] = "expired";
    CouponStatuses["INACTIVE"] = "inactive";
    CouponStatuses["LIMIT_REACHED"] = "limit_reached";
})(CouponStatuses = exports.CouponStatuses || (exports.CouponStatuses = {}));
